import React, { Component, Fragment } from "react";
//import "./styles.css";
import { connect } from "react-redux";
import { setActiveMenu } from "../../actions";
import { Waypoint } from "react-waypoint";
import M from "materialize-css";
import Server from "../Server";

class Footer extends Component {
	state = {
		data: []
	};
	componentWillMount() {
		fetch(Server.getFaq).then((res) => res.json()).then((data) => {
			this.setState({ data });
		});
	}

	componentDidMount() {
		var elems = document.querySelectorAll(".collapsible");
		var instances = M.Collapsible.init(elems, {
			accordion: false,
			onOpenStart: (obj, el) => {

				obj.firstChild.classList.add('shadowed');
				this.setState({
					isOpened: true
				});
			},
			onCloseStart: (obj, el) => {
				//obj.firstChild.classList.remove('shadowed');
				this.setState({
					isOpened: false
				});
			},
			onCloseEnd: (obj, el) => {
				obj.firstChild.classList.remove('shadowed');
			}
		});
	}

	handleExpand(id) {
		const data = new URLSearchParams(new FormData());
		data.append("id", id);
		//console.log(!window.localStorage[id]);
		if (!window.localStorage[id]) {
			fetch(Server.URL + "updatecount", {
			body: data,
			method: "POST"
		})
			.then((res) => res.json())
			.then((data) => {
				const question = this.state.data.filter((obj) => obj._id === id)[0];
				const index = this.state.data.indexOf(question);
				const newArray = [ ...this.state.data ];
				newArray[index] = { ...question, clicks: parseInt(question.clicks) + 1 };
				this.state.isOpened &&
					this.setState({
						data: newArray,
						isOpened: true
					});
			});
			window.localStorage[id] = id;
		}else {

		}




	}

	render() {
		const { langBase } = this.props;
		const items = this.state.data.map((e) => {
			return (
				<li key={e._id} className="collapsible-item" onClick={() => this.handleExpand(e._id)}>
					<div className="collapsible-header" style={{ display: "flex" }}>
						<div className="views counter">
							<div style={{ padding: "0 10px" }}>{e.clicks}</div>
							{/* <i className="material-icons">remove_red_eye</i> */}
						</div>
						<div className="faq-title">{e.question[langBase.abbr]} </div>
						<div className="views chevron">
							<i className="material-icons">chevron_left</i>
						</div>
					</div>
					<div className="collapsible-body">
						<span>{e.answer[langBase.abbr]}</span>
					</div>
				</li>
			);
		});
		return (
			<React.Fragment>
				<section className="social" style={{ display: "flex", background: "#d9d9d9" }}>
					<div className="socials">
						<a href="https://www.instagram.com/kalibri.pl/" target="_blank" rel="noopener noreferrer">
							<i className="fa fa-instagram" />
						</a>
						<a href="https://www.facebook.com/kalibripl/" target="_blank" rel="noopener noreferrer">
							<i className="fa fa-facebook-square" />
						</a>
					</div>
					<div className="weselezklasalogo">
						<span>{this.props.langBase.partner}</span>
						<a
							href="https://www.weselezklasa.pl/ogloszenia-weselne/kalibri-slubne-foto-i-wideo-klasy-premium,34859/"
							target="_blank"
							rel="noopener noreferrer"
							title="Kalibri - ślubne foto i wideo klasy premium">
							<img
								src="https://www.weselezklasa.pl/banery/Weselezklasa/button280x60szaretlobordowynapis.png"
								alt="Kalibri - ślubne foto i wideo klasy premium"
								border="0"
							/>
						</a>
					</div>
				</section>
				<footer id="contact" className="flex-rw">
					<Waypoint bottomOffset={300} onLeave={() => this.props.setActiveMenu(5)} />
					<Waypoint bottomOffset={300} onEnter={() => this.props.setActiveMenu(6)} />
					<div className="faq">
						<span>FAQ</span>
						<div className="flex" style={{ display: "flex", flexWrap: "wrap" }}>
							<div className="col-6 left-side">
								{" "}
								<ul className="collapsible expandable">
									{items.slice(0, Math.ceil(items.length / 2))}
								</ul>
							</div>
							<div className="col-6 right-side">
								{" "}
								<ul className="collapsible expandable">{items.slice(Math.ceil(items.length / 2))}</ul>
							</div>
						</div>
					</div>

					<section className="footer-bottom-section flex-rw">
						<div className="footer-bottom-wrapper">
							<i className="fa fa-copyright" role="copyright" /> 2019 Kalibri.pl &copy;{" "}
							<address className="footer-address" role="company address">
								Polska i cały świat.
							</address>
							<span className="footer-bottom-rights"> All Rights Reserved</span>
						</div>
						<div className="footer-bottom-wrapper">
							<a href="/terms-of-use.html" className="generic-anchor" rel="nofollow">
								Terms
							</a>{" "}
							|{" "}
							<a href="/privacy-policy.html" className="generic-anchor" rel="nofollow">
								Privacy
							</a>
						</div>
					</section>
				</footer>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	langBase: state.langBase
});

const mapDispatchToProps = {
	setActiveMenu
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
